// Interface d'observation du cycle de sync. Injectée dans OfflineSyncService
// pour découpler la logique (pure, testée avec fake-indexeddb) de toute
// dépendance UI / télémétrie (Sentry est câblé côté relais-front). Tous les
// hooks sont optionnels ; l'absence d'observer ⇒ no-op.
import type { SyncMutation } from "@relais/shared";
import type { FlushResult } from "./types.js";

export type SyncObserver = {
  onEnqueue?(e: { kind: SyncMutation["kind"]; taskId: string }): void;
  onFlushStart?(e: { batchSize: number }): void;
  onFlushEnd?(e: FlushResult): void;
  onNetworkError?(e: { phase: "flush"; message: string; batchSize: number }): void;
  onConflict?(e: { kind: SyncMutation["kind"]; taskId: string; reason: string }): void;
  // Une mutation atteint MAX_RETRY → purgée → la donnée terrain ne remontera
  // jamais. Signal de perte de données.
  onPurge?(e: {
    kind: SyncMutation["kind"];
    taskId: string;
    retryCount: number;
    reason: string;
  }): void;
  // Tâches retirées du snapshot serveur (dé-assignation admin, annulation…)
  // et purgées du local (tâche + render + medias + queue).
  onTasksPurged?(e: { taskIds: string[] }): void;
  onUploadError?(e: {
    taskId: string;
    mediaId: string;
    retryCount: number;
    exhausted: boolean;
    message: string;
  }): void;
};

export const NOOP_OBSERVER: SyncObserver = {};
